import { render, staticRenderFns } from "./schedule.vue?vue&type=template&id=4b64dca9&"
import script from "./schedule.vue?vue&type=script&lang=ts&"
export * from "./schedule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports